module.exports = __webpack_public_path__ + "media/images/checkout/challenger/plus-b9e0003697ca9a1acaef1c849abc9b4a.svg";